<template>
  <div>
    <v-card
      elevation="1"
      class="faktaruta"
      v-for="fact in speciesFacts"
      :key="fact.id"
    >
      <v-card-title v-text="fact.title_sve"></v-card-title>
      <v-card-text class="subtitle-1" v-html="fact.text_sve"></v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FactBox',
  props: {
    species: { type: Object, required: true }
  },
  data() {
    return {}
  },
  computed: {
    speciesFacts() {
      const facts = this.$store.state.facts

      const speciesFacts = facts.filter(
        fact => fact.spec_id === this.species.id
      )

      const subCatFacts = facts.filter(
        fact => this.species.life_group && fact.group === this.species.life_group 
      )
      return [...speciesFacts, ...subCatFacts]
    }
  }
}
</script>

<style lang="css" scoped>
.faktaruta {
  background: url(https://havetstore.blob.core.windows.net/bilder/livet-pwa/faktarutabg.png)
    top right no-repeat;

  padding: 10px 20px 10px;
  margin-top: 20px;
}
.faktaruta:nth-child(3n + 1) {
  background-color: rgba(26, 162, 97, 0.1);
}
.faktaruta:nth-child(3n + 2) {
  background-color: rgba(129, 123, 30, 0.1);
  background-color: rgba(26, 162, 97, 0.1);
}
.faktaruta:nth-child(3n + 3) {
  background-color: rgba(42, 127, 187, 0.1);
  background-color: rgba(26, 162, 97, 0.1);
}
</style>
